import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { getShowBrandHeading } from '../../../services/brands';
import type { BrandHeading } from '../../../types/brand';

type Props = {
  brandId: number;
  instagramIcon: string;
  noimage: string;
  dataCategory: string;
  dataValue: any;
  isStopped: boolean;
  isStoppedFv?: boolean;
};

export const Component: FunctionComponent<Props> = ({ brandId, instagramIcon, noimage, dataCategory, dataValue, isStopped, isStoppedFv }) => {
  const [brandHeadData, setBrandHeadData] = useState<BrandHeading | null>(null);

  useEffect(() => {
    const request = async () => {
      const response = await getShowBrandHeading(brandId);
      setBrandHeadData(response);
    };
    request();
  }, []);

  if (!brandHeadData) {
    return null;
  }

  return (
    <Presentation
      brandHeadData={brandHeadData}
      instagramIcon={instagramIcon}
      noimage={noimage}
      dataCategory={dataCategory}
      dataValue={dataValue}
      isStopped={isStopped}
      isStoppedFv={isStoppedFv}
    />
  );
};
